import React from 'react';

import { Layout } from '../../utils/theme/Layout';

const Card: React.FC = props => {
  return <Layout>{props.children}</Layout>;
};

export default Card;
